import React, { FunctionComponent } from 'react';

import { Text, Preset, Color } from '@lux/text';
import { ControlsArrowsNextS } from '@lux/icons';
import { FunctionColor } from '@lux/tokens';
import { ListItem, NestedItem, List } from './styles';
import { normalizePath, useNormalizedPath } from './hooks/use-normalized-path';

interface NestedListItemProps {
    title: string;
    url: string;
    showDivider?: boolean;
}

const NestedListItem: FunctionComponent<NestedListItemProps> = ({
    children,
    title,
    url,
    showDivider,
}) => {
    const path = useNormalizedPath();
    const normalizedUrl = normalizePath(url);
    const isActive = path === normalizedUrl;
    const opened = path.includes(normalizedUrl);

    return (
        <>
            {!children ? (
                <ListItem
                    key={title}
                    label={
                        <Text
                            preset={Preset.S}
                            color={isActive ? Color.primary : Color.dark}
                            bold={isActive}
                        >
                            {title}
                        </Text>
                    }
                    href={url}
                    noDivider={!showDivider}
                />
            ) : (
                <div>
                    <NestedItem
                        key={title}
                        label={
                            <Text
                                preset={Preset.S}
                                color={isActive ? Color.primary : Color.dark}
                                bold={isActive}
                            >
                                {title}
                            </Text>
                        }
                        rightAction={
                            <ControlsArrowsNextS
                                color={FunctionColor.function100}
                                style={{
                                    transform: `rotate(${!opened ? '90deg' : '270deg'})`,
                                    transition: '.3s ease-in-out',
                                }}
                            />
                        }
                        href={url}
                        noDivider={!showDivider}
                    />
                    {opened ? (
                        <>
                            <List disableBorders>
                                <>{children}</>
                            </List>
                        </>
                    ) : null}
                </div>
            )}
        </>
    );
};

export default NestedListItem;
